import swal from "sweetalert";

/**
 * @description Asigna una nueva URL al navegador
 * @param url
 */
export const redirect = (url: string) => {
  const newUrl = document.location.origin + url;
  window.location.replace(newUrl);
};

export const initSidebarMenu = () => {
  try {
    // @ts-ignore
    $.sidebarMenu($(".vertical-menu"));
  } catch (err) {}
};

export const showModal = (idModal: string) => {
  // @ts-ignore
  $(`#${idModal}`).modal("show");
};
export const hideModal = (idModal: string) => {
  // @ts-ignore
  $(`#${idModal}`).modal("hide");
};

export const addOnchangeSelect = (idSelect: string, callbackFN = null) => {
  // @ts-ignore
  $(`#${idSelect}`).on("change", () => {
    if (callbackFN) callbackFN();
  });
};

export const refreshMultiSelect = (idSelect: string, value: Array<string>) => {
  try {
    // @ts-ignore
    $(`#${idSelect}`).val(value);
    // @ts-ignore
    $(`#${idSelect}`).trigger("change");
  } catch (err) {}
};

export const refreshSelect = (idSelect: string, value: string) => {
  try {
    // @ts-ignore
    $(`#${idSelect}`).val(value);
    // @ts-ignore
    $(`#${idSelect}`).trigger("change");
  } catch (err) {}
};

export const refreshSelectInputs = () => {
  try {
    // @ts-ignore
    $(".select2-single").select2();
    // @ts-ignore
    $(".select2-multi-select").select2({
      placeholder: "Seleccionar",
    });
  } catch (err) {}
};

export const showPopUp = (title: string, message: string) => {
  swal(title, message);
};

export const showPopUpConfirmation = (
  title: string,
  text: string,
  callbackFN,
  dangerMode = true
) => {
  swal({
    title,
    text,
    icon: "warning",
    buttons: ["Cancelar", "Aceptar"],
    dangerMode,
  }).then((confirm) => {
    callbackFN(confirm);
  });
};

export const getURLParams = () => {
  return new URLSearchParams(window.location.search);
};

export const initSearchSelect = ({ id, selectedValue, onChange }) => {
  // @ts-ignore
  $(`#${id}`).hierarchySelect({
    hierarchy: false,
    resetSearchOnSelection: true,
    initialValueSet: selectedValue != null,
    width: "100%",
    onChange: function (value) {
      onChange(value);
    },
  });
};

export const setSearchSelectSelectedLabel = (
  id_select_search,
  selectedValue,
  arrayOptions = [],
  defaultEmptyLabel = ""
) => {
  const buttonSelectSearch = document.getElementById(`ssd_${id_select_search}`);
  if (!buttonSelectSearch) return;

  const findedOption = arrayOptions.find((o) => o.value === selectedValue);
  if (!findedOption) {
    buttonSelectSearch.innerText = defaultEmptyLabel;
    return;
  }

  buttonSelectSearch.innerText = findedOption.label;
};

export const copyToClipboard = (text) => {
  if (!navigator.clipboard) return;
  navigator.clipboard.writeText(text).then(
    function () {
      console.log("Texto copiado exitosamente");
    },
    function (err) {
      console.error("No se logro copiar el texto");
    }
  );
};
